import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { LdapTokenService } from '../../../core/services/ldap-token/ldap-token.service';

export const authGuard: CanActivateFn = (snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const ldapTokenService = inject(LdapTokenService);

  return ldapTokenService
    .isAuthenticated()
    .pipe(
      map((isAuthenticated) =>
        isAuthenticated ? true : createUrlTreeFromSnapshot(snapshot, ['/auth', 'login'], { redirectToUrl: state.url })
      )
    );
};
